import {ID, InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import StatusCarga from '@/model/resource/StatusCarga'
import DeliveryPeriodResponse from '@/model/response/DeliveryPeriodResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'
import * as moment from 'moment'
import {startCase, camelCase} from 'lodash'

export default (model: DeliveryPeriodResponse): Schema => ({

  mes: {
    content:   model.mes ? startCase(camelCase(moment.months(Number(model.mes) - 1).toString())) : model.mes,
  },

  qtdComOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdComOcorrencia,
      },
    },
    textContent: model.qtdComOcorrencia || '0',
  },

  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia,
      },
    },
    textContent: model.qtdSemOcorrencia || '0',
  },

  qtdDevolvidas: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdDevolvidas,
      },
    },
    textContent: model.qtdDevolvidas || '0',
  },

  qtdTotal: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdTotal,
      },
    },
    textContent: model.qtdTotal || '0',
  },

})
